import Service 			from "./../../Libs/Service";
import _ 				from "lodash";

let Metadata = new Service({

	Name: "Metadata",

	Events: {

	},

	Actions: {

		//Получение метаданных из БД
		"Metadata": function(metadata) {

			_.extend(this, metadata);

			this.ProjectPlayableSettingsByCodename = _.keyBy(metadata.ProjectPlayableSettings, "codename");
			this.ProjectPlayableSettingsPublisherByCodename = _.mapValues(_.groupBy(metadata.ProjectPlayableSettingsPublisher, "publisher_id"), v => _.keyBy(v, "codename"));
			this.ProjectBannerSettingsByCodename = _.keyBy(metadata.ProjectBannerSettings, "codename");
			this.ProjectBannerSettingsPublisherByCodename = _.mapValues(_.groupBy(metadata.ProjectBannerSettingsPublisher, "publisher_id"), v => _.keyBy(v, "codename"));

			this.WorkspacesByCodename = _.keyBy(metadata.Workspaces, "codename");
			this.ReleasesByCodename = _.keyBy(metadata.Releases, "codename");
			this.TemplatesByCodename = _.keyBy(metadata.Templates, "codename");
			this.DisplayObjectsByCodename = _.keyBy(metadata.DisplayObjects, "codename");
			this.DisplayObjectPropertiesByCodename = _.keyBy(metadata.DisplayObjectProperties, "codename");

			this.TemplateBannerAssetsByCodename = {};

			_.each(this.Templates, (template, templateId) => {

				this.TemplateBannerAssetsByCodename[templateId] = _.keyBy(_.filter(this.TemplateBannerAssets, {"template_id": parseInt(templateId)}), "codename");

			});

			this.TemplateBannerLocalizationByCodename = {};

			_.each(this.Templates, (template, templateId) => {

				this.TemplateBannerLocalizationByCodename[templateId] = _.keyBy(_.filter(this.TemplateBannerLocalization, {"template_id": parseInt(templateId)}), "codename");

			});

			this.TemplateBannerSettingsByCodename = {};

			_.each(this.Templates, (template, templateId) => {

				this.TemplateBannerSettingsByCodename[templateId] = _.keyBy(_.filter(this.TemplateBannerSettings, {"template_id": parseInt(templateId)}), "codename");

			});

			this.TemplateEndCardsByCodename = _.keyBy(this.TemplateEndCards, "codename");
			this.TemplateEndCardAssetsByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardAssets, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardLocalizationByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardLocalization, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardSettingsByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardSettings, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardScreensByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardScreens, "end_card_id"), objs => _.keyBy(objs, 'codename'));
			this.TemplateEndCardDisplayObjectsByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardDisplayObjects, "end_card_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.keyBy(objs, 'codename')));
			this.TemplateEndCardAnimationsByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardAnimations, "end_card_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.keyBy(objs, 'codename')));
			this.TemplateEndCardAnimationStepsByEndCardByCodename = _.mapValues(_.groupBy(metadata.TemplateEndCardAnimationSteps, "end_card_id"), objs => _.mapValues(_.groupBy(objs, "screen_codename"), objs => _.groupBy(objs, 'animation_codename')));

			this.TransitionsByCodename = _.keyBy(metadata.Transitions, 'codename');
			this.TransitionStepsByTransitionCodename = _.groupBy(metadata.TransitionSteps, "transition_codename");

			 Metadata.TemplatePlayablesByCodename = _.keyBy(metadata.TemplatePlayables, 'codename');

			document.title = Metadata.Config['dashboard-page-title'];

			this.loaded = true;

			Broadcast.call("Metadata Loaded");

		}

	},

	init() {

		this.loaded = false;

		this.Config = {};

		this.TextStylesByCodename = {
			//[Text]
			"textPortrait": 		{"engines": ["pixi", "three", "dom"], "type": "text", "value": "", "title": "Text portrait"},
			"textLandscape": 		{"engines": ["pixi", "three", "dom"], "type": "text", "value": "", "title": "Text landscape"},
			//[/Text]
			//[Font]
			"fontFamily": 			{"engines": ["pixi", "three", "dom"], "type": "string", "value": "", "title": "Font family"},
			"fontSize": 			{"engines": ["pixi", "three", "dom"], "type": "number", "step": 1, "min": 1, "value": 50, "title": "Font size"},
			"fontStyle": 			{"engines": ["pixi", "dom"], "type": "select", "value": "normal", "values": ["normal", "italic", "oblique"], "title": "Font style"},
			"fontVariant": 			{"engines": ["pixi", "dom"], "type": "select", "value": "normal", "values": ["normal", "small-caps"], "title": "Font variant"},
			"fontWeight": 			{"engines": ["pixi", "three", "dom"], "type": "select", "value": "normal", "values": ["normal", "bold", "bolder", "lighter", "100", "200", "300", "400", "500", "600", "700", "800", "900"], "title": "Font weight"},
			//[/Font]
			//[color]
			"fill":					{"engines": ["pixi", "dom"], "type": "color", "value": "#ffffff", "title": "Color"},
			//[/color]
			//[Stroke]
			"stroke": 				{"engines": ["pixi"], "type": "color", "value": "#000000", "title": "Stroke"},
			"strokeThickness": 		{"engines": ["pixi"], "type": "number", "step": 1, "min": 0, "value": 0, "title": "Stroke thickness"},
			"lineJoin" : 			{"engines": ["pixi"], "type": "select", "value": "miter", "values": ["miter", "round", "bevel"], "title": "Line join"},
			"miterLimit": 			{"engines": ["pixi"], "type": "number", "step": 1, "min": 0, "value": 0, "title": "Miter limit"},
			//[/Stroke]
			//[Layout]
			"letterSpacing": 		{"engines": ["pixi", "dom"], "type": "number", "step": 1, "value": 0, "title": "Letter spacing"},
			"textBaseline": 		{"engines": ["pixi"], "type": "select", "value": "alphabetic", "values": ["alphabetic", "bottom", "middle", "top", "hanging"], "title": "Text baseline"},
			//[/Layout]
			//[Drop Shadow]
			"dropShadow": 			{"engines": ["pixi", "three"], "type": "boolean", "title": "Drop shadow", "value": false},
			"dropShadowColor": 		{"engines": ["pixi", "three"], "type": "color", "value": "#000000", "title": "Shadow color"},
			"dropShadowAlpha": 		{"engines": ["pixi", "three"], "type": "number", "step": 0.01, "min": 0, "max": 1, "value": 0, "title": "Shadow alpha"},
			"dropShadowAngle": 		{"engines": ["pixi"], "type": "number", "step": 0.01, "min": 0, "max": 6.283, "value": 0, "title": "Shadow angle"},
			"dropShadowBlur": 		{"engines": ["pixi"], "type": "number", "step": 1, "value": 0, "title": "Shadow blur"},
			"dropShadowDistance": 	{"engines": ["pixi", "three"], "type": "number", "step": 1, "value": 0, "title": "Shadow distance"},
			//[/Drop Shadow]
			//[Multiline]
			"breakWords": 			{"engines": ["pixi", "dom"], "type": "boolean", "title": "Break words", "value": false},
			"wordWrap": 			{"engines": ["pixi", "dom"], "type": "boolean", "title": "Word wrap", "value": false},
			"wordWrapWidth": 		{"engines": ["pixi", "dom"], "type": "number", "step": 10, "min": 0, "value": 0, "title": "Word wrap width"},
			"align": 				{"engines": ["pixi", "dom"], "type": "select", "value": "left", "values": ["left", "center", "right"], "title": "Align"},
			"whiteSpace": 			{"engines": ["pixi", "dom"], "type": "select", "value": "normal", "values": ["normal", "pre", "pre-line"], "title": "White space"},
			"lineHeight": 			{"engines": ["pixi", "dom"], "type": "number", "step": 1, "min": 0, "value": "0", "title": "Line height"},
			"leading": 				{"engines": ["pixi"], "type": "number", "step": 1, "min": 0, "value": 0, "title": "Leading"},
			//[/Multiline]
			//[Texture]
			"padding": 				{"engines": ["pixi", "dom"], "type": "number", "step": 1, "min": 0, "value": 0, "title": "Padding"},
			"trim": 				{"engines": ["pixi"], "type": "boolean", "title": "Trim", "value": false}
			//[/Texture]
			//[Background]
			//[/Background]
		};

	},

	isReleaseAvailable(publisher, release) {

		if (!release['enabled']) return false;

		if (!release.options['scope'].includes(this.scope)) return false;

		if (release.codename in (publisher.options['Releases'] || {})) return publisher.options['Releases'][release.codename];

		return release.options["enabledByDefault"];

	}

});

//Только для наблюдения за состоянием через консоль браузера
window.Metadata = Metadata;

export { Metadata };

